import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export type ValidationProblemDetails = {
  /**
   * Um objeto que mapeia o nome do campo com erro para uma lista de mensagens de erro.
   * Por exemplo: { "workTimes[0].endTime": ["A data é inválida."] }
   */
  errors: {
    [key: string]: string[];
  };
  type: string;
  title: string;
  status: number;
  traceId?: string;
};

export type Feedback = {
  id: string | null;
  status: string | null;
  message?: string | null;
  errorCode?: string | null;
  timestamp?: string | null;
  environment?: string | null;
  exceptionMessage?: string | null;
  stackTrace?: string | null;
  innerExceptionMessage?: string | null;
  exceptionSource?: string | null;
  exceptionData?: Record<string, any> | null;
  alert: boolean;
};

type NotificationModal = {
  open: boolean;
};

const feedBackState: Feedback = {
  id: null,
  status: null,
  message: null,
  errorCode: null,
  timestamp: null,
  environment: null,
  exceptionMessage: null,
  stackTrace: null,
  innerExceptionMessage: null,
  exceptionSource: null,
  exceptionData: null,
  alert: true,
};

const notificationModalState: NotificationModal = {
  open: false,
};

export const feedBackSlice = createSlice({
  name: 'feedBackSlice',
  initialState: feedBackState,
  reducers: {
    changeFeedbackOption: (state, action: PayloadAction<Feedback>) => {
      state.id = action.payload.id;
      state.status = action.payload.status;
      state.alert = action.payload.alert;
      state.message = action.payload.message ?? null;
      state.errorCode = action.payload.errorCode ?? null;
      state.timestamp = action.payload.timestamp ?? null;
      state.environment = action.payload.environment;
      state.exceptionMessage = action.payload.exceptionMessage ?? null;
      state.stackTrace = action.payload.stackTrace ?? null;
      state.innerExceptionMessage =
        action.payload.innerExceptionMessage ?? null;
      state.exceptionSource = action.payload.exceptionSource ?? null;
      state.exceptionData = action.payload.exceptionData ?? null;
    },
  },
});

export const notificationModalSlice = createSlice({
  name: 'notificationModalSlice',
  initialState: notificationModalState,
  reducers: {
    changeModalValue: (state, action: PayloadAction<NotificationModal>) => {
      state.open = action.payload.open;
    },
  },
});

export const { changeFeedbackOption } = feedBackSlice.actions;

export const { changeModalValue } = notificationModalSlice.actions;
